/* tabヘッダー部分 */
app.component('headerTab', {
    template: '<md-tabs style="background-color:white;box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);" md-center-tabs md-border-bottom md-autoselect md-selected="$ctrl.selectedIndex">'+
              '<md-tab ng-repeat="category in ::$ctrl.recipeCategoryList" label="{{::category.name}}" md-on-select="$ctrl.tabChange($index)"></md-tab>'+
              '</md-tabs>',
    controller: function ($rootScope) {
        var $ctrl = this;
        $ctrl.tabChange = function(index) {
            $ctrl.selectedIndex = index;
            $rootScope.$broadcast("onTabChanged", index);
        };
    },
    bindings: {
        selectedIndex : '=',
        recipeCategoryList : "<"
    },
});

/* tab本体 */
app.component('bodyTab', {
    template: '<style>'+
              '.category { border-radius:5%; background-color:#03A9F4; color:#ffffff; padding: 2px 5px; margin:0px 5px; font-size: 12px; }'+
              '#recipe_tab { overflow-x: hidden; }'+
              '#recipe_tab md-list-item img { width:80px; margin-right:10px; max-width: 100%;}'+
              '.next-page.ng-hide-add,.next-page.ng-hide-add-active,.next-page.ng-hide-remove,.next-page.ng-hide-remove-active,.prev-page.ng-hide-add,.prev-page.ng-hide-add-active,.prev-page.ng-hide-remove,.prev-page.ng-hide-remove-active { -webkit-transition: 0.5s; -moz-transition: 0.5s; transition: 0.5s; }'+
              '.next-page.ng-hide-add { transform: translateX(0); }'+
              '.next-page.ng-hide-add-active { transform: translateX(-100%); }'+
              '.next-page.ng-hide-remove { transform: translateX(100%); }'+
              '.next-page.ng-hide-remove-active { transform: translateX(0); }'+
              '.prev-page.ng-hide-add { transform: translateX(0); }'+
              '.prev-page.ng-hide-add-active { transform: translateX(100%); }'+
              '.prev-page.ng-hide-remove { transform: translateX(-100%); }'+
              '.prev-page.ng-hide-remove-active { transform: translateX(0); }'+
              '</style>'+
              '<div id="recipe_tab" md-swipe-left="$ctrl.onSwipeLeft()" md-swipe-right="$ctrl.onSwipeRight()" style="margin-bottom:25px;">'+
              '<md-list ng-class="$ctrl.pagingName" ng-show="!$ctrl.pagingFlg">'+
              '<md-list-item class="md-2-line" ng-repeat="recipe in $ctrl.recipeList" ng-if="$ctrl.recipeEnableList[$ctrl.selectedIndex][$index]" ng-click="$ctrl.jumpDetailRecipe($index+1)">'+
              '<img ng-src="app/recipe/{{::recipe.contents.image}}" alt="{{::recipe.contents.title}}">'+
              '<div>'+
              '<p class="md-body-2" style="line-height:18px;">'+
              '{{::recipe.contents.title}}<br/>'+
              '<span class="category" ng-repeat="category in ::$ctrl.recipeCategoryList" ng-if="::recipe.contents.category[$index].belong">'+
              '{{::category.name}}'+
              '</span>'+
              '</p>'+
              '</div>'+
              '<md-divider ng-if="!$last"></md-divider>'+
              '</md-list-item>'+
              '</md-list>'+
              '</div>',
    controller: function ($scope, $location, $timeout, recipeInfo) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            $ctrl.jumpDetailRecipe = function(rno) {
                $location.path("/recipe_detail/"+rno+"/"+$ctrl.selectedIndex);
            };
            $scope.$on("onTabChanged", function(event, index) {
                if( $ctrl.selectedIndex < index ) {
                    $ctrl.pagingName = "next-page";
                    $ctrl.pagingFlg = true;
                    $timeout(function() {
                        $ctrl.selectedIndex = index;
                        $ctrl.pagingFlg = false;
                    }, 500);         
                };
                if( $ctrl.selectedIndex > index ) {
                    $ctrl.pagingName = "prev-page";
                    $ctrl.pagingFlg = true;
                    $timeout(function() {
                        $ctrl.selectedIndex = index;
                        $ctrl.pagingFlg = false;
                    }, 500);
                };
            });
            $ctrl.onSwipeLeft = function() {
                if( $ctrl.selectedIndex < $ctrl.recipeCategoryList.length-1 ) {
                    $ctrl.pagingName = "next-page";
                    $ctrl.pagingFlg = true;
                    $timeout(function() {
                        $ctrl.selectedIndex++;
                        $ctrl.pagingFlg = false;
                    }, 500);
                }
            };
            $ctrl.onSwipeRight = function() {
                if( $ctrl.selectedIndex > 0 ) {
                    $ctrl.pagingName = "prev-page";
                    $ctrl.pagingFlg = true;
                    $timeout(function() {
                        $ctrl.selectedIndex--;
                        $ctrl.pagingFlg = false;
                    }, 500);
                }
            };
        };
    },
    bindings: {
        selectedIndex : '=',
        recipeCategoryList : "<",
        recipeList : '<',
        recipeEnableList : '<'
    },
});

app.component('recipeMain', {
    templateUrl: 'app/recipe/recipe_main.html',
    controller: function ($routeParams, recipeInfo) {
        var $ctrl = this;
        $ctrl.recipeCategoryList = null;
        $ctrl.$onInit = function () {
            $ctrl.selectedIndex = $routeParams.tabIndex;
            $ctrl.recipeCategoryList = recipeInfo.getCategoryList();
            recipeInfo.loadRecipeList().then(function(response) {
                $ctrl.recipeList = response;
                $ctrl.recipeEnableList = recipeInfo.getEnableList($ctrl.recipeCategoryList, $ctrl.recipeList);
            });
        };
    }
});
